/**
 * getters
 *
 * @Author  Carey.zhou
 * @DATE    create on 2019/9/16
 * @DESC
 */

export const getters = {
  getQueryParam: state => {
    return state.queryParam
  },

  vno: state => {
    return state.queryParam.vno
  },

  startDate: state => {
    return state.queryParam.startDate
  },

  endDate: state => {
    return state.queryParam.endDate
  }
}
